import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { ElogioVO } from 'src/app/entity/ElogioVO';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { ElogioService } from 'src/app/service/elogio/elogio.service';
import { ERRO_ASSUNTO_OBRIGATORIO, ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS, OK_MANIFESTO_ENVIADO } from 'src/app/tools/Mensagens';
import { PAGINA_SUCESSO_FORM } from 'src/app/tools/URL';

@Component({
  selector: 'elogio',
  templateUrl: './elogio.component.html',
  styleUrls: ['./elogio.component.css']
})
export class ElogioComponent implements OnInit {
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;

  constructor(
    public service: ElogioService,
    public authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.service.carregarDados().subscribe(retorno => {
      this.service.elogio.controls.nome.setValue(this.authService.usuarioDTO.nome);
      this.service.elogio.controls.email.setValue(this.authService.usuarioDTO.email);
      if (retorno) {
        this.service.elogio.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.service.elogio.controls.assuntos.setValue(retorno.assuntos);
      }
    });
  }

  onSubmit() {
    if (this.service.elogio.value.assunto) {
      this.preencherDados();
      if (this.service.elogio.valid) {
        this.service.enviar(this.service.elogio.value).subscribe(retorno => {
          if (retorno) {
            alert(OK_MANIFESTO_ENVIADO);
            this.router.navigate([PAGINA_SUCESSO_FORM]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        const campos = this.tratarMensagemDeErro();
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  preencherDados() {
    this.service.elogio.controls.nome.setValue(this.authService.usuarioDTO.nome);
    this.service.elogio.controls.email.setValue(this.authService.usuarioDTO.email);
    this.service.elogio.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.elogio.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let contrutorElogioVO: any = ElogioVO.prototype.constructor;
    Object.values(this.service.elogio.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push('\n' + contrutorElogioVO.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  isAssuntoChecked(str) {
    return this.service.elogio.value.assunto &&
      this.service.elogio.value.assuntos
        .filter((assunto: any) => assunto.selected && assunto.value === str)
        .length > 0 ? true : false;
  }

  zeraListaClassificacao() {
    this.service.elogio.value.listaClassificacao = [];
  }

  changeAssunto(item) {
    this.service.elogio.controls.assunto.setValue(item);

    this.service.elogio.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.elogio.value.assuntos
      .filter(assunto => assunto.id === item.id)
      .forEach((assunto: any) => assunto.selected = true);

    this.service.elogio.value.assuntos
      .filter(assunto => assunto.id !== item.id)
      .forEach((assunto: any) => assunto.selected = false);

    this.resetFormControl();
  }

  resetFormControl() {
    this.service.elogio.controls.descricaoElogio.setValue('');
  }

  desmarcarCheckOutrosAssuntos() {
    this.service.elogio.value.listaClassificacaoCompleta
      .map(item => item.selecionado = false);

    this.service.elogio.controls.nomeElogiado.reset();
    this.service.elogio.controls.descricaoElogio.reset();
  }

}
